import React from "react"
import classnames from "classnames"
import gtmHandler from "AtomicUtils/gtmHandler"
import {
  A,
  Content,
  Caption,
  P,
  H6,
  Space,
  Interactive
} from "AtomicComponents"
import { Image } from "AtomicContainers"

import styles from "./Card.less"
class Card extends React.PureComponent {

  _handleOnClick = () => {
    const { onClick = () => { }, gtm, heading, linkText } = this.props
    onClick()

    // Call GTM if we have an gtm object
    if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
      gtmHandler({
        pageCategory: gtm.category,
        pageAction: gtm.action + `${linkText ? ` - Clicked ${linkText}` : ''}` + `${heading ? ` - ${heading}` : ''}`
      })
    }
  }

  render() {
    const {
      imageSrc,
      note,
      preHeading,
      heading,
      linkText,
      description,
      disclaimer,
      featured = false,
      transparent = false,
      contain = false,
      outline = true,
      onClick
    } = this.props

    return (
      <div
        className={classnames({
          [styles.Card]: true,
          [styles.CardFeatured]: featured,
          [styles.CardTransparent]: transparent,
          [styles.CardLink]: linkText || onClick,
          [styles.CardOutline]: outline
        })}
        data-test="card"
        onClick={this._handleOnClick}
      >
        {/* First Section */}
        {imageSrc && imageSrc != "" &&
        <div
          className={classnames({
            [styles.FirstSection]: true,
            [styles.FirstSectionContain]: contain
          })}
        >
          <Image src={imageSrc} type="withoutShowing" />
          {
            disclaimer &&
            <div
              className={classnames({
                [styles.FirstSectionDisclaimer]: true
              })}
            >
              <Caption>{disclaimer}</Caption>
            </div>
          }
        </div>
        }
        {/* Second Section */}
        {(heading || description) &&
          <div className={classnames({
            [styles.SecondSection]: true,
            [styles.CardWithLink]: linkText && linkText != ""
          })}>
            <div>
              {note &&
                <P withoutMargin>
                  {note}
                </P>
              }
              {preHeading &&
                <Interactive>
                  {preHeading}
                </Interactive>
              }
              {preHeading && <Space />}
              {heading &&
                <H6 withDetails>
                  {heading}
                </H6>
              }
            {(description || linkText) && <Space />}
              {description &&
              <div
                className={classnames({
                  [styles.CardAreaContent]: true
                })}>
                <Content xmlString={description} />
              </div>
            }
            </div>
          </div>
        }
        {/* Third Section */}
        {linkText && linkText != "" &&
          <div className={classnames({
            [styles.ThirdSection]: true
          })}>
            <A
            withoutStyle
            className={classnames({
              [styles.ThirdSectionLink]: true
            })}>
              <Interactive>
                {linkText}
              </Interactive>
            </A>
          </div>
        }
      </div>
    )
  }
}


export default Card




// WEBPACK FOOTER //
// ./src/AtomicComponents/Card/Card.jsx